import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";
import { AppBadge } from "Components/AppBadge";

export const AppBadgeStyle = styled(AppBadge)({
  paddingLeft: "8px",
  paddingRight: "8px",
  paddingTop: "4px",
  paddingBottom: "4px",
  borderRadius: "4px",

  fontFamily: "Manrope",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "16px",
  letterSpacing: "0.5px",
  display: "inline-flex",
  alignItems: "center",
  gap: "8px",

  "& > span": {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    maxWidth: "100px",
  },
});

export const AppBadgeTitle = styled("span")({
  fontFamily: "Manrope",
  fontSize: 12,
  fontWeight: 700,
  lineHeight: "16px",
  letterSpacing: 0.5,
  color: colors.gray600,
  marginRight: 4,
});

export const WrapperBadge = styled("div")(
  ({ isAlignEnd, isAlignCenter }: { isAlignEnd?: boolean; isAlignCenter?: boolean }) => ({
    textAlign: isAlignEnd ? "end" : isAlignCenter ? "center" : "start",
    width: "100%",
  })
);
